export default __webpack_public_path__ + "static/media/ThirtyDayDemo.e7de564c.mov";